import { THEME_CONFIG } from './themeConfig';

/*export const getActiveTheme = (override = null) => {
  if (override && THEME_CONFIG[override]) {
    return {
      key: override,
      ...THEME_CONFIG[override],
    };
  }

  const today = new Date();
  const month = today.getMonth() + 1;
  const day = today.getDate();
  const current = `${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;

  const getActiveTheme = (month, day) => {
    switch (month) {
      case 1: // January
        if (day <= 7) return { key: 'newyear', ...THEME_CONFIG.newyear };
        if (day >= 20) return { key: 'republicDay', ...THEME_CONFIG.republicDay };
        break;

      case 2: // February
        return { key: 'valentine', ...THEME_CONFIG.valentine };
        break

      case 8: // August
        if (day >= 10 && day <= 20) {
          return { key: 'independenceDay', ...THEME_CONFIG.independenceDay };
        }
        break;

      case 12: // December
        if (day >= 20) return { key: 'christmas', ...THEME_CONFIG.christmas };
        break;

      default:
        // You can return a default theme here (like Summer or Winter)
        return { key: 'summer', ...THEME_CONFIG.summer };
    }
};

  // Dynamic festival windows — checked before seasonal fallbacks
  const festivalWindows = [
    { start: '03-01', end: '03-31', key: 'holi' },
    { start: '04-01', end: '04-20', key: 'eid' },
    { start: '10-01', end: '10-20', key: 'dussehra' },
    { start: '10-21', end: '11-10', key: 'diwali' },
  ];

  for (const festival of festivalWindows) {
    if (current >= festival.start && current <= festival.end) {
      return {
        key: festival.key,
        ...THEME_CONFIG[festival.key],  // fix: was missing spread
      };
    }
  }

// ... (previous festival cases here)

  // Seasonal Fallbacks
  switch (month) {
    case 3:
    case 4:
    case 5:
      return { key: 'summer', ...THEME_CONFIG.summer };

    case 6:
    case 7:
    case 8:
    case 9:
      return { key: 'monsoon', ...THEME_CONFIG.monsoon };

    case 10:
    case 11:
      return { key: 'autumn', ...THEME_CONFIG.autumn };

    case 12:
      // This handles Dec 1-19 if your festival check didn't trigger
      return { key: 'winter', ...THEME_CONFIG.winter };

    case 1:
    case 2:
      // Handles January 8–19 and any gaps in February
      return { key: 'winter', ...THEME_CONFIG.winter };

    default:
      return { key: 'summer', ...THEME_CONFIG.summer };
  }
}*/

export const getActiveTheme = (override = null) => {
  if (override && THEME_CONFIG[override]) {
    return { key: override, ...THEME_CONFIG[override] };
  }

  const today = new Date();
  const month = today.getMonth() + 1;
  const day = today.getDate();
  const current = `${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;

  // 1. FIXED HOLIDAYS (Removed the inner function wrapper)
  switch (month) {
    case 1:
      if (day <= 7) return { key: 'newyear', ...THEME_CONFIG.newyear };
      if (day >= 20) return { key: 'republicDay', ...THEME_CONFIG.republicDay };
      break;
    case 2:
      return { key: 'valentine', ...THEME_CONFIG.valentine };
    case 8:
      if (day >= 10 && day <= 20) return { key: 'independenceDay', ...THEME_CONFIG.independenceDay };
      break;
    case 12:
      if (day >= 20) return { key: 'christmas', ...THEME_CONFIG.christmas };
      break;
    // ADDED THIS TO FIX THE ERROR
    default:
      break;
  }

  // 2. DYNAMIC FESTIVALS
  const festivalWindows = [
    { start: '03-01', end: '03-31', key: 'holi' },
    { start: '04-01', end: '04-20', key: 'eid' },
    { start: '10-01', end: '10-20', key: 'dussehra' },
    { start: '10-21', end: '11-10', key: 'diwali' },
  ];
  console.log(current)
  for (const festival of festivalWindows) {
    if (current >= festival.start && current <= festival.end) {
      return { key: festival.key, ...THEME_CONFIG[festival.key] };
    }
  }

  // 3. SEASONAL FALLBACKS (If nothing else matches)
  switch (month) {
    case 3: case 4: case 5:
      return { key: 'summer', ...THEME_CONFIG.summer };
    case 6: case 7: case 8: case 9:
      return { key: 'monsoon', ...THEME_CONFIG.monsoon };
    case 10: case 11:
      return { key: 'autumn', ...THEME_CONFIG.autumn };
    default:
      return { key: 'winter', ...THEME_CONFIG.winter };
  }
};